import { render, staticRenderFns } from "./InfoCard.vue?vue&type=template&id=1ba9536f&scoped=true&"
import script from "./InfoCard.vue?vue&type=script&lang=ts&"
export * from "./InfoCard.vue?vue&type=script&lang=ts&"
import style0 from "./InfoCard.vue?vue&type=style&index=0&id=1ba9536f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba9536f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
